import { gql } from '@apollo/client';
import { TripPlannerDocument, TripPlannerQuery, TripPlannerQueryVariables } from '../../generated/graphql';
import usePlannerQuery from '../planner/usePlannerQuery';

export const plannerQuery = gql`
    query TripPlanner($slug: String!, $start: String!, $end: String!, $persons: Int!, $pets: Int!, $babies: Int!) {
        rentalUnit(slug: $slug) {
            id
            name
            code
            brand
            type
            accommodation {
                id
                type
            }
            trips(pets: $pets, persons: $persons, babies: $babies, startDate: $start, endDate: $end) {
                ...PlannerTrip
            }
        }
    }

    fragment PlannerTrip on Trip {
        date
        price
        duration
        type
        originalPrice
        specialId
    }
`;

const useTripPlannerQuery = (variables: TripPlannerQueryVariables) =>
    usePlannerQuery<TripPlannerQuery, TripPlannerQueryVariables>(variables, TripPlannerDocument);

export default useTripPlannerQuery;
